module.exports = __webpack_public_path__ + "img/car_sendai13.9649dc9b.jpg";